import React from 'react';
import SDK from '../../SDK';
import { useSelector } from 'react-redux';
import { store } from '../../Redux/store';
import WebChatProfileImg from '../WebChat/Profile/WebChatProfileImg';
import { getFormatPhoneNumber, capitalizeFirstLetter } from '../../Helpers/Utility';
import { CALL_ENGAGED_STATUS_MESSAGE, CALL_SESSION_STATUS_CLOSED, DISCONNECTED_SCREEN_DURATION, } from '../../Helpers/Call/Constant';
import { dispatchDisconnected, getCallDisplayDetailsForOnetoManyCall } from '../../Helpers/Call/Call';
import {  getUserDetails } from '../../Helpers/Chat/User';
import SmallVideo from "./SmallVideo"
import Logo from "../../assets/images/new-images/logoNew.png";
import { getGroupData } from '../../Helpers/Chat/Group';
import CallerProfileList from "./CallerProfileList";
import { deleteItemFromLocalStorage, encryptAndStoreInLocalStorage} from '../../Helpers/Chat/webChatEncryptDecrypt';
import { BackToChatHoc } from '../../assets/images';
import CallControlButtons from './CallControlButtons';
import { addShowConfrenceData } from '../../Redux/feature/showConfrenceDataSlice';
import { resetCallData } from '../../callback';
import callLogs from './CallLogs/callLog';
import { isUserWhoBlockedMe } from '../../Helpers/Chat/BlockContact';
//Call switch
const WebCallingLayout = (props) => {
    const {endCallAction = ()=> {}} = props
    let audio = window.outgoingRingTone;
    let audioConnecting = window.outgoingRingTone;
    let timer = null;
    let uiChangetimer = null;

    const globalState = useSelector((state) => state);
    const { showConfrenceData,vCardData,callConnectionDate } = globalState
    const addCustomCall = useSelector(state => state.addCustomCall.data)

    const [webCalls,setWebCalls] = React.useState({
        callConnectionDate: "",
        showMemberNames: false,
        callingUiStatus: "Trying to connect"
    })

    React.useEffect(()=>{
        if (callConnectionDate && callConnectionDate.data) {
            setWebCalls({...webCalls, callConnectionDate: callConnectionDate.data })
        }
        document.querySelectorAll('audio').forEach(element => {
            element.pause();
        });
        uiChangetimer = setTimeout(() => {
            setWebCalls({...webCalls,
                callingUiStatus: "User seems to be offline, Trying to connect"
            });
        }, 10000);
        timer = setTimeout(() => {
            endCall()
        }, 30000);

        return ()=>{
            stopAudio();
            clearTimeout(timer)
            clearTimeout(uiChangetimer)
        }
    },[])

    React.useEffect(()=>{
        audio.load();
        props.stopSound ? stopAudio() : playAudio(callConnectionData.roomId);
    },[])

    const playAudio = (roomId) => {
        let audioPromise = null;
        if (roomId) {
            stopConnectingAudio();
            audioPromise = audio.play();
            audio.loop = true;
        } else {
            audioPromise = audioConnecting.play();
            audioConnecting.loop = true;
        }

        if (audioPromise !== undefined) {
            audioPromise
                .then(_ => {
                    // autoplay started
                })
                .catch(err => {
                    // catch dom exception
                    console.info(err)
                })
        }
    }

    const stopAudio = () =>{
        audio.loop = false;
        audio.pause();
        audio.currentTime = 0;
        stopConnectingAudio()
    }
    const stopConnectingAudio =() => {
        audioConnecting.loop = false;
        audioConnecting.pause();
        audioConnecting.currentTime = 0;
    }

    const handleAudioMute = (audioMute) => {
        return;
    }

    const handleVideoMute = (videoMute) => {
        return;
    }

    const toggleMemberNames = () => {
        setWebCalls({ ...webCalls,
            showMemberNames: !webCalls.showMemberNames });
    }

    const handleHideCallScreen =(e)=> {
        e.stopPropagation();
        props.hideCallScreen();
    }

    const displayGroupMemberNames = () => {
        if (callConnectionDate && callConnectionDate.data && callConnectionDate.data.callMode === "onetomany") {
            let userList = callConnectionDate.data.userList.split(",");
            let callUserDetails = [];
            if (userList.length > 0) {
                userList.map(member => {
                    let rosterDataGroup = getUserDetails(member);
                    callUserDetails.push(rosterDataGroup);
                });
                return callUserDetails.map((user) => {
                    const { displayName, name, username, jid, GroupUser } = user
                    let DisplayName = displayName || name || jid || username || getFormatPhoneNumber(GroupUser)
                    return (<li key={jid}>{DisplayName}</li>)
                });
            }
            return [];
        }
        return [];
    }

    const endCall = async () => {
        stopAudio();
        const callConnectionDataEndCall = callConnectionDate?.data;
        SDK.endCall();
        endCallAction();
        dispatchDisconnected();
        resetCallData();
        callLogs.update(callConnectionDataEndCall.roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": CALL_SESSION_STATUS_CLOSED
        });
        setTimeout(() => {
            encryptAndStoreInLocalStorage('callingComponent',false)
            deleteItemFromLocalStorage('roomName')
            deleteItemFromLocalStorage('callType')
            deleteItemFromLocalStorage('call_connection_status')
            encryptAndStoreInLocalStorage("hideCallScreen", false);
            store.dispatch(addShowConfrenceData({
                showComponent: false,
                showCalleComponent:false,
                stopSound: true,
                callStatusText: null
            }))
        }, DISCONNECTED_SCREEN_DURATION);
    }

    const isOneToManyCall = () => {
        let isOnecallConnectionData = callConnectionDate.data;
        return isOnecallConnectionData.callMode === "onetomany" && !isOnecallConnectionData.groupId;
    }

    const getGroupDetails = (groupId) => {
        let rosterDataGD = {};
        let group = getGroupData(groupId);
        rosterDataGD.displayName = group.groupName;
        rosterDataGD.image = group.groupImage;
        rosterDataGD.thumbImage = group.thumbImage;
        rosterDataGD.jid = group.groupId;
        rosterDataGD.chatType = "groupchat";
        rosterDataGD.initialName = "";
        return rosterDataGD;
    }

    const getRosterDataForCall = () => {
        let user = "";
        let getRosterData = {};
        let getcallConnectionData = callConnectionDate.data;
        if (getcallConnectionData.callMode === "onetoone") {
            user = getcallConnectionData.to;
            getRosterData = getUserDetails(user);
        } else if (getcallConnectionData.callMode === "onetomany") {
            if (getcallConnectionData.groupId !== "" && getcallConnectionData.groupId !== null && getcallConnectionData.groupId !== undefined) {
                user = getcallConnectionData.groupId.includes("@") ? getcallConnectionData.groupId.split('@')[0] : getcallConnectionData.groupId
                getRosterData = getGroupDetails(user);
            } else {
                let userList = getcallConnectionData.userList.split(",");
                getRosterData = getCallDisplayDetailsForOnetoManyCall(userList);
            }
        }
        return getRosterData;
    }

    let {  callStatus } = props;
    if (!callConnectionDate || !callConnectionDate.data) {
        return null;
    }
    let rosterData = getRosterDataForCall();
    let callConnectionData = callConnectionDate.data;
    let vcardData = { ...vCardData.data };
    let chatType = rosterData.chatType;
    let callType = (callConnectionDate.data.callType === "audio" || callConnectionDate.data.callType === "Audio") ? "Audio " : "Video ";
     let toUser = "";
    if (callConnectionDate.data.from && callConnectionDate.data.to) {
        if (callConnectionDate.data.to) {
            toUser = callConnectionDate.data.to.includes('@') ? callConnectionDate.data.to.split('@')[0] : callConnectionDate.data.to
        } else {
            toUser = callConnectionDate.data.from.includes('@') ? callConnectionDate.data.from.split('@')[0] : callConnectionDate.data.from
        }
    }
    let audioControl = true;
    let videoControl = true;
    if (callType === "Audio") {
        videoControl = false;
    }
    let callingUiStatus = webCalls.callingUiStatus;
    vcardData.nickname = "You";
    let localVideoMuted = showConfrenceData.data.localVideoMuted;
    let localAudioMuted = showConfrenceData.data.localAudioMuted;
    let localStream = showConfrenceData.data.localStream; 

    return(
        <div className="calling-Popup webcall-calling">
            {!addCustomCall && 
                <div className="optionButton visible">
                    <div>
                        <span title="Back to chat" className="BackToChat" onClick={handleHideCallScreen}>
                            <i className="backIcon"><span className="toggleAnimation"></span><BackToChatHoc /></i>
                        </span>
                    </div>
                </div>
            }
            {isOneToManyCall() &&
                <div className="callDetails">
                    <div style={{ visibility: "hidden" }} className="logosm">
                        <img src={Logo} alt="Logo" />
                    </div>
                    <CallerProfileList rosterData={rosterData} />
                    <div className="calleeDetails">
                        <div className="calle-info">
                            <span className="callerName" title={rosterData.displayName}>{rosterData.displayName ? rosterData.displayName : toUser}</span>
                            {callConnectionDate.data.callMode === "onetomany" && callConnectionDate.data.groupId &&
                                <span className="memmber-details" onClick={toggleMemberNames} >
                                    ({callConnectionData.userList && callConnectionData.userList.split(",").length > 0 ? callConnectionData.userList.split(",").length : 0} {callConnectionData.userList.split(",").length > 1 ? "members" : "member"})
                                    {webCalls.showMemberNames &&
                                        <div className="popup-group-member">
                                            <ul className="group-member-list">
                                                {displayGroupMemberNames()}
                                            </ul>
                                        </div>
                                    } 
                                </span>
                            } 
                        </div>
                        <span className="callingStatus">
                            <span>
                                {callStatus === "Calling" ? webCalls.callingUiStatus : capitalizeFirstLetter(callStatus)} {(callStatus === 'Calling' || callStatus === 'Ringing') &&
                                    <div className="callingAnimation call">
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                    </div>
                                }
                            </span>
                        </span>
                    </div>
                </div>
            }

            {!isOneToManyCall() &&
                <div className="avatar-wrapper">
                    <div className="avatar" id="dominantSpeakerAvatar">
                        <div className="calling-animation-wrapper">
                            <WebChatProfileImg
                                blocked={isUserWhoBlockedMe(rosterData.userId)}
                                // name = {iniTail}
                                chatType={chatType}
                                rostersnap={rosterData.thumbImage !== "" ? rosterData.thumbImage : rosterData.image}
                                jid={(rosterData.username) ? rosterData.username : rosterData.jid} />
                            <div className="ripple-1"></div>
                            <div className="ripple-2"></div>
                            <div className="ripple-3"></div>
                        </div>
                        <div className="calleeDetails">
                            <div className="calle-info">
                                <span className="callerName">{rosterData.displayName ? rosterData.displayName : toUser}</span>                                
                                    {callConnectionDate.data.callMode === "onetomany" && callConnectionDate.data.groupId &&
                                        <span className="memmber-details" >
                                            ({callConnectionData.userList && callConnectionData.userList.split(",").length > 0 ? callConnectionData.userList.split(",").length : 0} {callConnectionData.userList.split(",").length > 1 ? "members" : "member"})
                                            {webCalls.showMemberNames &&
                                                <div className="popup-group-member">
                                                    <ul className="group-member-list">
                                                        {displayGroupMemberNames()}
                                                    </ul>
                                                </div>
                                            } 
                                        </span>
                                    } 
                            </div>
                            <span className="callingStatus">
                                <span className={`${callStatus === CALL_ENGAGED_STATUS_MESSAGE ? "call-state-busy": ""} call-status`}>
                                    {callStatus === "Calling" ? callingUiStatus : capitalizeFirstLetter(callStatus)} {(callStatus === 'Calling' || callStatus === 'Ringing') &&
                                        <div className="callingAnimation call">
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                        </div>
                                    }
                                </span>
                            </span>                            
                        </div>
                    </div>
                </div>
            }
            <div>
                {localStream &&
                    <div className="content-body">
                        <div className="RemoteVideo-wrapper">
                            <div data-overlap-id="call-thumbnail-view-local" className="RemoteVideo-list">
                                <SmallVideo
                                    elKey={`local-user-video-${vcardData.fromUser}`}
                                    videoMuted={localVideoMuted}
                                    audioMuted={!localAudioMuted}
                                    stream={localStream}
                                    rosterData={vcardData}
                                    jid={vcardData.fromUser}
                                    showConfrenceDataId={showConfrenceData.id}
                                    pinUserJid={null}
                                    setPinUser={false}
                                    callStatus={callStatus}
                                    inverse={true}
                                />
                            </div>
                        </div>
                    </div>
                }
                <CallControlButtons
                    cssClassName="disabled-btn"
                    handleEndCall={endCall}
                    handleAudioMute={handleAudioMute}
                    handleVideoMute={handleVideoMute}
                    videoMute={!!localVideoMuted}
                    audioMute={true}
                    audioControl={audioControl}
                    videoControl={videoControl}
                />
            </div>
        </div>
    )
}
export default WebCallingLayout;